import { gql } from '@apollo/client';
export const CompanyDetailsFragment = gql `
  fragment CompanyDetailsFragment on Company2 {
    id
    name
    organizationNumber
    addressStreet
    addressZip
    addressCity
    addressCountry
  }
`;
